<template>
  <div class="logo">
    <svg
      class="pf-logo"
      width="100%"
      height="100%"
      viewBox="0 0 187 177"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xml:space="preserve"
      xmlns:serif="http://www.serif.com/"
      style="
        fill-rule: evenodd;
        clip-rule: evenodd;
        stroke-linejoin: round;
        stroke-miterlimit: 2;
      "
    >
      <g id="toolbox-logo" serif:id="toolbox logo">
        <rect
          x="145.524"
          y="44.267"
          width="39.266"
          height="132.345"
          style="fill: #169893"
        />
        <path
          d="M160.362,158.348l-0,4.532l-2.814,-0l-0,-12.39l2.814,0l-0,4.533l12.405,-0l-0,3.325l-12.405,-0Z"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <path
          d="M170.316,141.76c-0,-2.986 -2.558,-4.107 -5.095,-4.107c-2.664,-0 -5.222,1.121 -5.222,4.107c0,2.987 2.558,4.109 5.222,4.109c2.537,0 5.095,-1.122 5.095,-4.109m-13.131,0c0,-4.68 3.517,-7.432 8.036,-7.432c4.392,-0 7.909,2.752 7.909,7.432c-0,4.681 -3.517,7.434 -7.909,7.434c-4.519,0 -8.036,-2.753 -8.036,-7.434"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <path
          d="M170.316,125.066c-0,-2.986 -2.558,-4.108 -5.095,-4.108c-2.664,-0 -5.222,1.122 -5.222,4.108c0,2.987 2.558,4.108 5.222,4.108c2.537,0 5.095,-1.121 5.095,-4.108m-13.131,-0c0,-4.681 3.517,-7.433 8.036,-7.433c4.392,-0 7.909,2.752 7.909,7.433c-0,4.68 -3.517,7.433 -7.909,7.433c-4.519,0 -8.036,-2.753 -8.036,-7.433"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <path
          d="M157.548,115.148l-0,-3.325l12.406,-0l-0,-7.369l2.813,0l-0,10.694l-15.219,-0Z"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <path
          d="M170.166,99.049l0,-3.558c0,-1.313 -0.425,-2.456 -2.003,-2.456c-1.556,0 -2.174,0.974 -2.174,2.392l0,3.622l4.177,-0Zm-6.458,-0l0,-3.367c0,-1.166 -0.533,-2.034 -1.812,-2.034c-1.45,0 -1.747,1.102 -1.747,2.288l-0,3.113l3.559,-0Zm-6.16,3.325l0,-7.116c0,-2.88 0.938,-4.829 3.773,-4.829c1.491,0 2.536,0.741 3.176,2.054c0.532,-1.842 1.96,-2.773 3.858,-2.773c3.09,0 4.412,2.604 4.412,5.336l0,7.328l-15.219,-0Z"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <path
          d="M170.316,80.47c-0,-2.986 -2.558,-4.109 -5.095,-4.109c-2.664,-0 -5.222,1.123 -5.222,4.109c0,2.986 2.558,4.109 5.222,4.109c2.537,-0 5.095,-1.123 5.095,-4.109m-13.131,-0c0,-4.681 3.517,-7.434 8.036,-7.434c4.392,0 7.909,2.753 7.909,7.434c-0,4.68 -3.517,7.434 -7.909,7.434c-4.519,-0 -8.036,-2.754 -8.036,-7.434"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <path
          d="M164.795,66.846l-7.247,4.871l-0,-3.855l4.86,-2.964l-4.86,-3.071l-0,-3.642l7.269,4.849l7.95,-5.273l-0,3.96l-5.264,3.304l5.264,3.367l-0,3.749l-7.972,-5.295Z"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <rect
          x="-0"
          y="44.267"
          width="132.166"
          height="132.345"
          style="fill: #2b5358"
        />
        <path
          d="M20.76,102.732l-3.484,0l-0,-3.003l3.484,-0l0,-3.083c0,-3.364 2.003,-5.125 5.727,-5.125c0.64,0 1.561,0.119 2.202,0.32l0,2.962c-0.6,-0.2 -1.321,-0.28 -1.922,-0.28c-1.642,-0 -2.603,0.521 -2.603,2.323l0,2.883l4.004,-0l0,3.003l-4.004,0l0,17.7l-3.404,-0l0,-17.7Z"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <path
          d="M40.143,117.909c3.564,0 6.447,-2.804 6.447,-7.808c-0,-5.046 -2.883,-7.849 -6.447,-7.849c-3.564,0 -6.447,2.803 -6.447,7.849c0,5.004 2.883,7.808 6.447,7.808m0,-18.66c6.567,-0 10.051,4.765 10.051,10.852c0,6.046 -3.484,10.811 -10.051,10.811c-6.567,0 -10.051,-4.765 -10.051,-10.811c-0,-6.087 3.484,-10.852 10.051,-10.852"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <path
          d="M68.257,106.376c-0.52,-2.601 -2.322,-4.124 -5.125,-4.124c-4.926,-0 -6.448,3.884 -6.448,8.088c0,3.805 1.723,7.57 6.047,7.57c3.284,-0 5.246,-1.923 5.687,-5.047l3.483,0c-0.761,5.047 -3.924,8.049 -9.129,8.049c-6.328,-0 -9.691,-4.406 -9.691,-10.572c-0,-6.206 3.204,-11.092 9.771,-11.092c4.684,0 8.448,2.203 8.929,7.128l-3.524,0Z"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <path
          d="M92.847,120.432l-3.204,-0l-0,-3.284l-0.08,0c-1.442,2.563 -3.764,3.764 -6.727,3.764c-5.447,0 -7.128,-3.124 -7.128,-7.568l0,-13.616l3.404,0l0,14.017c0,2.522 1.601,4.164 4.204,4.164c4.125,0 6.127,-2.763 6.127,-6.487l-0,-11.694l3.404,0l-0,20.704Z"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <path
          d="M100.059,113.905c0.12,3.043 2.762,4.004 5.566,4.004c2.123,-0 5.005,-0.481 5.005,-3.084c0,-2.642 -3.364,-3.083 -6.767,-3.845c-3.364,-0.759 -6.768,-1.88 -6.768,-5.845c0,-4.165 4.125,-5.887 7.728,-5.887c4.566,0 8.21,1.442 8.49,6.488l-3.404,0c-0.24,-2.643 -2.562,-3.484 -4.805,-3.484c-2.042,-0 -4.405,0.56 -4.405,2.643c-0,2.442 3.605,2.844 6.768,3.604c3.403,0.76 6.768,1.882 6.768,5.886c-0,4.925 -4.607,6.527 -8.811,6.527c-4.644,-0 -8.569,-1.882 -8.769,-7.007l3.404,-0Z"
          style="fill: #ffffff; fill-rule: nonzero"
        />
        <path
          d="M9.481,10.05c-4.412,0 -6.116,3.789 -6.116,7.539c0,3.942 1.781,7.576 6.309,7.576c4.49,-0 6,-3.827 6,-7.731c-0,-3.75 -1.935,-7.384 -6.193,-7.384m-9.289,-2.434l3.289,-0l-0,2.705l0.077,0c1.084,-2.203 3.639,-3.169 6.388,-3.169c6.154,0 9.212,4.87 9.212,10.513c0,5.644 -3.019,10.398 -9.135,10.398c-2.051,0 -4.994,-0.772 -6.465,-3.13l-0.077,-0l-0,10.32l-3.289,0l-0,-27.637Z"
          style="fill: #2b5358; fill-rule: nonzero"
        />
        <path
          d="M22.916,7.615l3.097,0l0,4.214l0.078,-0c1.587,-3.209 3.793,-4.793 7.354,-4.677l0,3.479c-5.304,-0 -7.238,3.015 -7.238,8.078l-0,8.891l-3.291,0l0,-19.985Z"
          style="fill: #2b5358; fill-rule: nonzero"
        />
        <path
          d="M44.556,25.165c3.445,-0 6.232,-2.706 6.232,-7.538c0,-4.871 -2.787,-7.577 -6.232,-7.577c-3.444,0 -6.231,2.706 -6.231,7.577c-0,4.832 2.787,7.538 6.231,7.538m-0,-18.013c6.348,-0 9.715,4.599 9.715,10.475c0,5.837 -3.367,10.436 -9.715,10.436c-6.348,0 -9.716,-4.599 -9.716,-10.436c0,-5.876 3.368,-10.475 9.716,-10.475"
          style="fill: #2b5358; fill-rule: nonzero"
        />
        <path
          d="M66.74,25.165c4.413,-0 6.115,-3.789 6.115,-7.538c-0,-3.943 -1.781,-7.577 -6.309,-7.577c-4.49,0 -5.999,3.827 -5.999,7.732c-0,3.749 1.934,7.383 6.193,7.383m9.288,2.434l-3.289,0l0,-2.705l-0.077,0c-1.084,2.203 -3.638,3.169 -6.387,3.169c-6.155,0 -9.213,-4.87 -9.213,-10.513c0,-5.644 3.02,-10.398 9.136,-10.398c2.051,-0 4.993,0.772 6.464,3.131l0.077,-0l0,-10.283l3.289,-0l0,27.599Z"
          style="fill: #2b5358; fill-rule: nonzero"
        />
        <path
          d="M97.671,27.6l-3.096,-0l-0,-3.17l-0.079,-0c-1.392,2.474 -3.637,3.634 -6.502,3.634c-5.264,-0 -6.89,-3.015 -6.89,-7.306l0,-13.143l3.29,0l0,13.529c0,2.436 1.549,4.021 4.064,4.021c3.988,0 5.922,-2.668 5.922,-6.262l0,-11.288l3.291,0l-0,19.985Z"
          style="fill: #2b5358; fill-rule: nonzero"
        />
        <path
          d="M116.216,14.032c-0.503,-2.513 -2.245,-3.982 -4.955,-3.982c-4.761,0 -6.231,3.75 -6.231,7.808c0,3.673 1.664,7.307 5.844,7.307c3.175,-0 5.071,-1.856 5.497,-4.871l3.367,-0c-0.735,4.871 -3.793,7.769 -8.825,7.769c-6.115,0 -9.367,-4.251 -9.367,-10.205c-0,-5.991 3.097,-10.706 9.445,-10.706c4.529,0 8.167,2.126 8.632,6.88l-3.407,0Z"
          style="fill: #2b5358; fill-rule: nonzero"
        />
        <path
          d="M127.987,7.615l3.986,0l0,2.9l-3.986,-0l-0,12.407c-0,1.508 0.425,1.779 2.477,1.779l1.509,-0l0,2.899l-2.515,0c-3.407,0 -4.761,-0.696 -4.761,-4.368l-0,-12.717l-3.406,-0l-0,-2.9l3.406,0l-0,-5.991l3.29,-0l-0,5.991Z"
          style="fill: #2b5358; fill-rule: nonzero"
        />
      </g>
    </svg>
  </div>
</template>

<style>
  .pf-logo {
    animation: 0.3s appear;
    margin: auto;
  }

  @keyframes appear {
    0% {
      opacity: 0%;
    }
  }
</style>
